import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorWarehouseStockItemSearch = () => {
  const stockItemSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/warehouse/stock-item/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { stockItemSearch }
}

export default InteractorWarehouseStockItemSearch
